'use strict';
angular
    .module('MW.Influencers.AlertController',
           ['MW.Influencers.IcmDialogService',
            'MW.Framework.AppChromeService',
            'ngCookies'])
    .controller('AlertCtrl', ['$location', '$scope', 'DialogService', '$timeout', '$sce', 'AppChromeService', '$cookies', function($location, $scope, DialogService, $timeout, $sce, AppChromeService, $cookies) {
    $scope.alerts = DialogService.flashMessages;

    $scope.$watch('alerts', function scopeWatchAlerts() {
        angular.forEach($scope.alerts, function(alert) {
            if (typeof alert.html !== 'undefined') {
                return;
            }

            alert.html = alert.text;

            if (alert.timeout > 0) {
                alert.timeoutId = $timeout(function onTimeout() {
                    $scope.removeAlert(alert);
                }, alert.timeout*1000);
            }
        });
    }, true);

    $scope.appChromeService = AppChromeService.getCurrentModel();

    $scope.removeAlert = function(alert) {
        var idx = $.inArray(alert, $scope.alerts);
        if (idx > -1){
            if (alert.persistDismissInSession) {
                $cookies.put('mw_' + alert.uniqueId, 1);
            }
            $scope.alerts.splice(idx, 1);
        }
    };

    $scope.$on('$routeChangeSuccess', function($event, newRoute) {
        angular.forEach($scope.alerts, function(alert, index) {
            if (alert.hideOnPageChange) {
                $scope.alerts.splice(index, 1);
                if (typeof alert.timeoutId !== 'undefined') {
                    $timeout.cancel(alert.timeoutId);
                }
            }
        });

        $scope.isPageChromeless = (newRoute && newRoute.$$route && newRoute.$$route.isChromeless) ? true : false;
    });
    }]).directive('compile', ['$compile', function ($compile) {
        return function(scope, element, attrs) {
            scope.$watch(
                function(scope) {
                    // watch the 'compile' expression for changes
                    return scope.$eval(attrs.compile);
                },
                function(value) {
                    // when the 'compile' expression changes
                    // assign it into the current DOM
                    element.html(value);

                    // compile the new DOM and link it to the current
                    // scope.
                    // NOTE: we only compile .childNodes so that
                    // we don't get into infinite loop compiling ourselves
                    $compile(element.contents())(scope);
                }
            );
        };
    }]);
